import Chip, { ChipProps } from '@mui/material/Chip'

const EMPTY_FIELD = 'No data'

export const EmptyFieldChip = ({ label = EMPTY_FIELD, ...restOfProps }: ChipProps) => {
  return <Chip label={label} {...restOfProps} />
}
